import styled from 'styled-components';

export const LaborContainer = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
`;

export const Card = styled.div`
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #fff;
  flex-grow: 2;
  min-width: 0;
`;

export const DiscountCard = styled.div`
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #fff;
  flex-grow: 1;
  min-width: 0;
`;

export const CardHeader = styled.div`
  background: #fff;
  height: 60px;
  padding: 0 30px;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ced6e5;
`;

export const CardTitle = styled.div`
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 700;
  color: #000000;
`;

export const CardBody = styled.div`
  padding: 30px;
`;
